class NameGenerator {
    private alphabet: string = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    private index: number = 0;
    private names: string[] = [];

    constructor() {
        this.generateSingleLetters();
    }

    private generateSingleLetters() {
        for (const letter of this.alphabet) {
            this.names.push(letter);
        }
    }

    private generateDoubleLetters() {
        const firstLetter = this.alphabet[Math.floor(this.index / 26)];
        const secondLetter = this.alphabet[this.index % 26];
        this.names.push(firstLetter + secondLetter);
    }

    public getNextName(): string {
        if (this.index < this.names.length) {
            return this.names[this.index++];
        } else {
            this.generateDoubleLetters();
            return this.names[this.index++];
        }
    }
}

export default NameGenerator;
